export enum LOCALS {
  RU_RU = 'ru-RU',
  RU = 'ru',
  UK = 'uk',
}
